import type { PeopleListProps } from './people-list.interface';
import type { FC } from 'react';

import { usePermissions } from '../../../contexts/permissions.context';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import { EntityPanel } from '../../panels/entity-panel/entity-panel';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';

export const PeopleList: FC<PeopleListProps> = ({
  people,
  panelClick,
  createClick,
  isSelectable,
}: PeopleListProps) => {
  const matrix = usePermissions();

  const createPersonBtn = (): JSX.Element | undefined => {
    if (matrix.permissions.createNew === true) {
      return (
        <CreateButton
          text={vocabulary.buttons.createNewPeople}
          onClick={createClick}
        />
      );
    }
  };

  return people.list.length > 0 ? (
    <div className={'entities-list'}>
      {people.list.map((people, index) => (
        <EntityPanel
          isSelectable={isSelectable}
          onClick={() => panelClick(people)}
          key={index}
          title={people.name}
          id={people.id}
        />
      ))}
      {createPersonBtn()}
    </div>
  ) : (
    <>
      <NotFoundMessage
        message={` Nicht gefunden: Personen konnten nicht gefunden werden.`}
      />
      {createPersonBtn()}
    </>
  );
};
